import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  INVITATIONSOURCETYPE_CSV,
  INVITATIONSOURCETYPE_EXCEL,
  INVITATIONSOURCETYPE_INVITATION_GROUP,
  INVITATIONSOURCETYPE_PERSONAL,
} from '../../../../../../constants/api';
import { setIsNotificationPanelOpen } from '../../../../../../features/componentFeatures/notificationPanelSlice';
import { getAttr } from '../../../../../../features/helpers/apiHelpers';
import {
  setIsFileInviteePanelOpen,
  setIsInvitationGroupInviteePanelOpen,
  setIsPersonalInviteePanelOpen,
} from '../../../../../../features/pageFeatures/createHearingPageSlice';
import { noSelectionKey } from '../../../../../../utilities/filterAndSortingsUtil';

export const useInteractions = () => {
  const dispatch = useDispatch();

  const [selectedInvitationSource, setSelectedInvitationSource] = useState(
    noSelectionKey,
  );

  function handleEditInvitationNotificationClick() {
    dispatch(setIsNotificationPanelOpen(true));
  }

  function handleInvitationSourceClick(source) {
    const invitationSourceType = getAttr(source, 'invitationSourceType');

    switch (invitationSourceType) {
      case INVITATIONSOURCETYPE_CSV:
      case INVITATIONSOURCETYPE_EXCEL:
        dispatch(setIsFileInviteePanelOpen(true));
        break;
      case INVITATIONSOURCETYPE_PERSONAL:
        dispatch(setIsPersonalInviteePanelOpen(true));
        break;
      case INVITATIONSOURCETYPE_INVITATION_GROUP:
        dispatch(setIsInvitationGroupInviteePanelOpen(true));
        break;
      default:
        break;
    }
    setSelectedInvitationSource(source);
  }
  return {
    selectedInvitationSource,
    handleInvitationSourceClick,
    handleEditInvitationNotificationClick,
  };
};
